// The app's single data handle. Every read and write goes to the on-device store
// (@battleops/localstore); the sync engine ships the outbox to the VPS in the background.
// `db` is kept only so the Firestore-shaped call sites (`doc(db, 'tasks', id)`) stay unchanged.
export const db = null;
